module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.b594fe8b.ttf";